import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getMosAction } from "src/features/mos/state/getMosAction";
import { MosError, MosItemType, MosState } from "src/features/mos/types";

const initialState: MosState = {
  error: null,
  loading: false,
  items: [],
  lineupId: null,
};

const slice = createSlice({
  name: "mos",
  initialState,
  reducers: {
    removeItemsByType: (state, action: PayloadAction<MosItemType>) => {
      const itemType = action.payload;
      state.items = state.items.filter((item) => item.type !== itemType);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMosAction.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getMosAction.fulfilled, (state, { payload }) => {
        state.items = payload.items;
        state.lineupId = payload.lineupId;
        state.loading = false;
      })
      .addCase(getMosAction.rejected, (state, { payload }) => {
        state.error = payload?.message ?? MosError.SOMETHING_WENT_WRONG;
        state.loading = false;
      });
  },
});

export const { removeItemsByType } = slice.actions;
export const mosReducer = slice.reducer;
